import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    account: graphql(`
        fragment hasAccountReachedMaxUsers_Account on AccountType {
            users {
                number
            }
        }
    `),
}

export function hasAccountReachedMaxUsers(account: FragmentOf<typeof graphQLFragments.account>) {
    const { users } = readFragment(graphQLFragments.account, account)

    return Boolean(users && users.length >= 2)
}

hasAccountReachedMaxUsers.fragments = graphQLFragments
